import ApiConfig from "../Config";
import apiService from "../services/apiService";

const dashBoardService = {
  dashboardAPI: () => apiService.get(ApiConfig.dashboardAPI),
};
export default dashBoardService;
